// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class QpsignatureDocument {
    static getAttributeTypeMap() {
        return QpsignatureDocument.attributeTypeMap;
    }
}
QpsignatureDocument.discriminator = undefined;
QpsignatureDocument.additionalProperties = false;
QpsignatureDocument.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "applyAnchorTabs",
        "baseName": "applyAnchorTabs",
        "type": "boolean"
    },
    {
        "name": "transformPdfFields",
        "baseName": "transformPdfFields",
        "type": "boolean"
    },
    {
        "name": "documentBase64",
        "baseName": "documentBase64",
        "type": "string"
    },
    {
        "name": "checkboxTabs",
        "baseName": "checkboxTabs",
        "type": "Array<QpsignatureTab>"
    },
    {
        "name": "dateSignedTabs",
        "baseName": "dateSignedTabs",
        "type": "Array<QpsignatureTab>"
    },
    {
        "name": "initialHereTabs",
        "baseName": "initialHereTabs",
        "type": "Array<QpsignatureTab>"
    },
    {
        "name": "listTabs",
        "baseName": "listTabs",
        "type": "Array<QpsignatureTabList>"
    },
    {
        "name": "radioGroupTabs",
        "baseName": "radioGroupTabs",
        "type": "Array<QpsignatureTabGroup>"
    },
    {
        "name": "signHereTabs",
        "baseName": "signHereTabs",
        "type": "Array<QpsignatureTab>"
    },
    {
        "name": "textTabs",
        "baseName": "textTabs",
        "type": "Array<QpsignatureTab>"
    },
];
//# sourceMappingURL=qpsignatureDocument.js.map